<template>
  <LandingLayout>
    <NewOrder in-landing />
  </LandingLayout>
</template>

<script>
  import LandingLayout from '@/containers/LandingLayout';
  import NewOrder from '@/pages/new-order';
  export default {
    name: 'Landing',
    components: {NewOrder, LandingLayout},
    created () {
      const oldStyles = document.getElementById('main-styles');
      if (oldStyles) oldStyles.remove();

      const css = document.createElement('link');
      css.setAttribute('href', '/landing/landing-webflow.css');
      css.setAttribute('type', 'text/css');
      css.setAttribute('rel', 'stylesheet');
      css.setAttribute('id', 'landing-styles');
      document.head.appendChild(css);
    },
  };
</script>

<style lang="scss">
  .brand-logo.header {
    padding-right: 0px;
    padding-left: 0px;
}
.order-form {
  position: relative;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media screen and (max-width: 480px) {
    .title {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 15px;
    }
  }

  .clear-form {
    cursor: pointer;
    color: #eb5757;
    padding: 4px 12px;
    border-radius: 4px;
    height: 30px;
    background-color: rgba(235, 87, 87, 0.12);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

  .option.option-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .price.form-order {
    margin-bottom: 12px;
    padding: 0px;
    background-color: transparent;
  }
  .add-item {
    .form-block.form-block-price {
      padding: 0;
    }
    .h3 {
      margin-top: 20px;
    }
  }
  .options-grid {
    .option {
      background-color: rgba(32, 37, 58, 0.04);
    }
  }
  .m0 {
    .options-grid {
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-column-gap: 4px;
      grid-row-gap: 4px;
      grid-template-rows: 1fr;
    }
  }
</style>

<!--<style lang="scss" src="../containers/new-order/page-embed.scss"></style>-->
